$(document).ready(function() {
    App.init();
    App.advantagesSlider('.js-advantages');
    App.partnersSlider('.js-partners');
    App.initMenu('.js-menu');
    App.initTabs('.js-tabs');
    App.bottomForm('.js-form');
    App.contentPopup('.js-popup');
    App.fixedHeader('.js-header');
});
